import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonHttpErrorService } from '@core/error-handler/common-http-error.service';
import { CommonError } from '@core/error-handler/common-error';
import {
  GetNewsListRequestDto,
  GetNewsListResponseDto,
  NewsRequestDto,
  NewsResponseDto,
} from './category-grp/grp.model';

@Injectable({
  providedIn: 'root',
})
export class GrpserviceService {
  constructor(
    private httpClient: HttpClient,
    private commonHttpErrorService: CommonHttpErrorService
  ) {}

  // Updated service method to accept pagination parameters
  getNewsList(
    request: GetNewsListRequestDto
  ): Observable<GetNewsListResponseDto | CommonError> {
    const url = `api/GRP/GetNewsDataList`;
    const params = new HttpParams()
      .set('PageNumber', request.pageNumber.toString())
      .set('PageSize', request.pageSize.toString())
      .set('SearchText', request.searchText || '');

    return this.httpClient
      .get<GetNewsListResponseDto>(url, { params })
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  // Get single news by Id
  getNewsById(id: number): Observable<NewsResponseDto | CommonError> {
    const url = `api/GRP/GetNewsDataById?id=${id}`;
    return this.httpClient
      .get<NewsResponseDto>(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  // Insert / Update / Delete / Approve (same API)
  saveNews(news: NewsRequestDto): Observable<NewsResponseDto | CommonError> {
    const url = `api/GRP/ManageNewsRecord`;
    return this.httpClient
      .post<NewsResponseDto>(url, news)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  // Updated service method to accept pagination parameters
  GetMarqueeList(request: any): Observable<any | CommonError> {
    const url = `api/GRP/GetMarqueeList`;
    const params = new HttpParams()
      .set('PageNumber', request.pageNumber.toString())
      .set('PageSize', request.pageSize.toString())
      .set('SearchText', request.searchText || '');

    return this.httpClient
      .get<any>(url, { params })
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  // Get single news by Id
  GetMarqueeDataById(id: number): Observable<any | CommonError> {
    const url = `api/GRP/GetMarqueeDataById?id=${id}`;
    return this.httpClient
      .get<any>(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  // Insert / Update / Delete / Approve (same API)
  ManageMarqueeRecord(news: any): Observable<any | CommonError> {
    const url = `api/GRP/ManageMarqueeRecord`;
    return this.httpClient
      .post<NewsResponseDto>(url, news)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  UpdateManageNewsRecord(news: any): Observable<any | CommonError> {
    const url = `api/GRP/UpdateManageNewsRecord`;
    return this.httpClient
      .post<NewsResponseDto>(url, news)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  UpdateManageMarqueeRecord(news: any): Observable<any | CommonError> {
    const url = `api/GRP/UpdateManageMarqueeRecord`;
    return this.httpClient
      .post<NewsResponseDto>(url, news)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }
  // ========== CATEGORY (SUBJECT) OPERATIONS ==========

  /**
   * Get paginated list of categories/subjects
   */
  getSubjectList(pageNumber = 1, pageSize = 10): Observable<any | CommonError> {
    const url = `api/GRP/GetSubjectList?PageNumber=${pageNumber}&PageSize=${pageSize}`;
    return this.httpClient
      .get<any>(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Get a single category/subject by ID
   */
  getSubjectById(id: number): Observable<any | CommonError> {
    const url = `api/GRP/GetSubjectDataById?id=${id}`;
    return this.httpClient
      .get<any>(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Create a new category/subject
   */
  createSubject(subject: any): Observable<any | CommonError> {
    const url = `api/GRP/AddSubjectRecord`;
    return this.httpClient
      .post(url, subject)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Update an existing category/subject
   */
  updateSubject(subject: any): Observable<any | CommonError> {
    const url = `api/GRP/UpdateSubjectRecord`;
    return this.httpClient
      .put(url, subject)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Delete a category/subject
   */
  deleteSubject(id: number): Observable<any | CommonError> {
    const url = `api/GRP/DeleteSubjectRecord?id=${id}`;
    return this.httpClient
      .delete(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  // ========== SUBCATEGORY OPERATIONS ==========

  /**
   * Get all subcategories for a given parent category ID
   */
  getSubCategories(categoryId: string | number): Observable<any | CommonError> {
    const url = `api/GRP/GetSubCategoryList?id=${categoryId}`;
    return this.httpClient
      .get<any>(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Get a single subcategory by ID
   */
  getSubCategoryDataById(id: number): Observable<any | CommonError> {
    const url = `api/GRP/GetSubCategoryDataById?id=${id}`;
    return this.httpClient
      .get<any>(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Create a new subcategory
   */
  createSubCategory(subCategory: any): Observable<any | CommonError> {
    const url = `api/GRP/AddSubCategoryRecord`;
    return this.httpClient
      .post(url, subCategory)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Update an existing subcategory
   */
  updateSubCategory(subCategory: any): Observable<any | CommonError> {
    const url = `api/GRP/UpdateSubCategoryRecord`;
    return this.httpClient
      .put(url, subCategory)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }

  /**
   * Delete a subcategory
   */
  deleteSubCategory(id: number): Observable<any | CommonError> {
    const url = `api/GRP/DeleteSubCategoryRecord?id=${id}`;
    return this.httpClient
      .delete(url)
      .pipe(catchError(this.commonHttpErrorService.handleError));
  }
}
